// src/services/api.js — FIXED
// Fix: updateMenuItem uses PUT, createMenuItem uses POST
// Fix: all menu calls use correct endpoints

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

// withCredentials sends httpOnly cookies automatically on every request
const api = axios.create({ baseURL: API_URL, withCredentials: true });

// ── Auth ──────────────────────────────────────────────────────
export const login    = (data) => api.post('/auth/login',    data);
export const register = (data) => api.post('/auth/register', data);
export const getMe    = ()     => api.get('/auth/me');

// ── Menu ──────────────────────────────────────────────────────
export const getMenu        = (params) => api.get('/menu', { params });
export const getMenuItem    = (id)     => api.get(`/menu/${id}`);
export const createMenuItem = (data)   => api.post('/menu', data);
export const updateMenuItem = (id, data) => api.put(`/menu/${id}`, data);   // ← PUT
export const toggleMenuItem = (id)     => api.patch(`/menu/${id}/toggle`);
export const deleteMenuItem = (id)     => api.delete(`/menu/${id}`);
export const updateStock    = (id, stock) => api.post(`/menu/${id}/stock`, { stock });

// ── Modifiers ─────────────────────────────────────────────────
export const getModifiers     = (itemId)           => api.get(`/menu/${itemId}/modifiers`);
export const getModifiersFull = (itemId)           => api.get(`/menu/${itemId}/modifiers/full`);
export const createGroup      = (itemId, data)     => api.post(`/menu/${itemId}/modifiers/groups`, data);
export const updateGroup      = (itemId, gId, data) => api.patch(`/menu/${itemId}/modifiers/groups/${gId}`, data);
export const deleteGroup      = (itemId, gId)      => api.delete(`/menu/${itemId}/modifiers/groups/${gId}`);
export const createOption     = (itemId, gId, data) => api.post(`/menu/${itemId}/modifiers/groups/${gId}/options`, data);
export const updateOption     = (itemId, oId, data) => api.patch(`/menu/${itemId}/modifiers/options/${oId}`, data);
export const deleteOption     = (itemId, oId)      => api.delete(`/menu/${itemId}/modifiers/options/${oId}`);
export const importModifiers  = (itemId, data)     => api.post(`/menu/${itemId}/modifiers/import`, data);

// ── Orders ────────────────────────────────────────────────────
export const getOrders        = (params) => api.get('/orders', { params });
export const getOrder         = (id)     => api.get(`/orders/${id}`);
export const placeOrder       = (data)   => api.post('/orders', data);
export const updateOrderStatus = (id, status) => api.patch(`/orders/${id}/status`, { status });
export const cancelOrder      = (id)     => api.patch(`/orders/${id}/cancel`);
export const cancelUnpaid     = (id)     => api.patch(`/orders/${id}/cancel-unpaid`);

// ── Payments ──────────────────────────────────────────────────
export const initiatePayment  = (orderId, gateway) => api.post('/payments/initiate', { orderId, gateway });
export const confirmPayment   = (paymentId, ref)   => api.post('/payments/confirm',  { paymentId, gatewayRef: ref });

// ── Billing ───────────────────────────────────────────────────
export const validateDiscount = (code, vendorId, subtotal) =>
  api.post('/billing/discount/validate', { code, vendorId, orderSubtotal: subtotal });

// ── Vendors ───────────────────────────────────────────────────
export const getVendors    = ()       => api.get('/vendors');
export const getVendor     = (id)     => api.get(`/vendors/${id}`);
export const updateVendor  = (id, d)  => api.patch(`/vendors/${id}`, d);

// ── Franchise / Chain ─────────────────────────────────────────
export const getFranchiseChain  = (hubId)                 => api.get(`/franchise/chain/${hubId}`);
export const getFranchiseStatus = (vendorId)              => api.get(`/franchise/status/${vendorId}`);
export const getFranchiseLogs   = (vendorId)              => api.get(`/franchise/logs/${vendorId}`);
export const syncFranchiseAll   = (hubId, mode)           => api.post(`/franchise/sync/${hubId}`, { mode });
export const syncFranchiseOne   = (hubId, targetId, mode) => api.post(`/franchise/sync/${hubId}/${targetId}`, { mode });
export const setFranchiseHub    = (data)                  => api.patch('/franchise/set-hub', data);

// ── Analytics ─────────────────────────────────────────────────
//export const getAnalytics = (params) => api.get('/analytics', { params });
// ── Analytics ─────────────────────────────────────────────────
export const getAnalytics  = (params) => api.get('/analytics', { params });
export const getDashboard  = (params) => api.get('/analytics/dashboard', { params });

export default api;
